import {FC, PropsWithChildren} from 'react';
import {Box, Center, Flex} from '@chakra-ui/react';

interface IProps extends PropsWithChildren {
  step: number;
  title: string;
}

export const VerifyStep: FC<IProps> = ({step, title, children}) => {
  return (
    <Box>
      <Flex alignItems={'center'} gap={'8px'}>
        <Center w={'24px'} h={'24px'} rounded={'full'} bg={'{gradients.accent}'} color={'white'}>
          {step}
        </Center>
        <Box fontWeight={600}>{title}</Box>
      </Flex>
      <Box pl={'32px'} pt={'8px'}>
        {children}
      </Box>
    </Box>
  );
};
